import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css'],
})

export class OrganizationBranch implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Organization");

  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/organization/organization.component.ts